import { render, staticRenderFns } from "./ThirdPartyRegisterListItem.vue?vue&type=template&id=75020d10&"
import script from "./ThirdPartyRegisterListItem.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyRegisterListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CGridItem: require('@chakra-ui/vue').CGridItem, CGrid: require('@chakra-ui/vue').CGrid, CFlex: require('@chakra-ui/vue').CFlex})
